export default {
	id: 'emptyDashboard',
	name: 'Empty',
	description: 'A blank dashboard',
	items: []
}